export default {
      id: "icon-send-usage",
      viewBox: "0 0 100 97",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-send",
      toString: function () {
        return this.url;
      }
    }